module.exports = __webpack_public_path__ + "static/media/img_7-2.037bcb70.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/v2/img_7-2.svg
// module id = 741
// module chunks = 0